var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.tag,{tag:"tag",class:[ 'section-title', { 'no-bg-color': _vm.noBgColor } ],style:(_vm.headStyle)},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }